import React, { useState, useEffect, useRef } from 'react'

const TeamTab = ({ setEdit, teamData, setSelectUser, handleUpdateTeamUser, setIsSaveLoading, isSaveLoading, handleActionUser, isSuspendLoading, LazyImage }) => {

    const [email, setEmail] = useState('')
    const [reasonSuspension, setReasonSuspension] = useState('')
    const [reasonRestore, setReasonRestore] = useState('')
    const [selectedMemberName, setSelectedMemberName] = useState('')
    const [selectedMember, setSelectedMember] = useState('')
    const [openTeamMemberPopup, setOpenTeamMemberPopup] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [reason, setReason] = useState('')
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (selectedMember?.email) {
            setEmail(selectedMember?.email);
        }
        if (teamData.length > 0 && !selectedMember) {
            setSelectedMember(teamData[0]);
            setSelectedMemberName(teamData[0]?.name);
        }
    }, [selectedMember, teamData]);

    const handleSuspend = async (selectedMember) => {
        setErrorMessage('');

        if (!reason?.trim()) {
            setErrorMessage("Please enter reason for suspension.");
            return;
        }
        const data = await handleActionUser(reason, selectedMember)
        if (data) {
            setReason('')
        }
    }

    const handleSave = async () => {
        if (!email?.trim()) {
            setEmailErrorMessage('Please fill personal email address.');
            return;
        }
        setIsSaveLoading(true);
        if (email?.trim() === teamData?.email?.trim()) {
            setTimeout(() => {
                setIsSaveLoading(false);
                setEdit(false);
            }, 500);
            return;
        }

        const updatedMember = {
            ...selectedMember,
            email: email
        };
        await handleUpdateTeamUser(updatedMember);
    };

    return (
        <>
            {
                selectedMemberName !== '' && selectedMember?.status === 1 &&
                <>
                    <div className={`select-box-section ${selectedMemberName !== '' && 'filled'}`}>
                        <div className={`select-box`} onClick={() => { setOpenTeamMemberPopup(!openTeamMemberPopup) }}>
                            <span>{selectedMemberName}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M18 8.88281L12 14.8828L6 8.88281" stroke="#05171A" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <span className='label'>Team member</span>
                        {
                            openTeamMemberPopup &&
                            <div className='team-member'>
                                {teamData
                                    .filter(member => member?.status === 1)
                                    .map((member, index) => (
                                        <div
                                            key={index}
                                            className="team-name"
                                            onClick={() => {
                                                setSelectedMemberName(member?.name);
                                                setOpenTeamMemberPopup(false);
                                                setSelectedMember(member);
                                            }}
                                        >
                                            {member?.name}
                                        </div>
                                    ))}
                            </div>
                        }
                    </div>
                    <div className='vc-edit-section'>
                        <div className='vc-details'>
                            {
                                selectedMember?.profileImg &&
                                <div className='vc-dummy-image'>
                                    <LazyImage
                                        src={selectedMember?.profileImg}
                                        alt="founder"
                                    />
                                </div>
                            }
                            <div className='vc-detail-section'>
                                <div>
                                    <span className='label'>Full name</span>
                                    <div className='value'>{selectedMember?.name}</div>
                                </div>
                                <div>
                                    <span className='label'>Job title</span>
                                    <div className='value'>{selectedMember?.jobTitle}</div>
                                </div>
                                <div>
                                    <span className='label'>LinkedIn profile</span>
                                    <div className='value'>{selectedMember?.linkedInUrl}</div>
                                </div>
                                <div>
                                    <span className='label'>Short bio</span>
                                    <div className='value'>{selectedMember?.about}</div>
                                </div>
                                <div>
                                    <span className='label'>Startups invested in</span>
                                    <div className='value'>{selectedMember?.investedIn}</div>
                                </div>
                                <div>
                                    <span className='label'>Easy scheduling URL</span>
                                    <div className='value'>{selectedMember?.scheduleUrl}</div>
                                </div>
                            </div>
                            <div className='divider'></div>
                            <div className='email-section'>
                                <div className={`input-group ${email ? 'filled' : ''} ${emailErrorMessage && 'show-error'}`}>
                                    <input type="email" id='email' name='email' autoComplete="off" value={email} onChange={(e) => {
                                        setEmail(e.target.value);
                                        if (emailErrorMessage) setEmailErrorMessage('');
                                    }} />
                                    <label htmlFor="email">Email Address</label>
                                </div>
                                {emailErrorMessage && <p className="error-message">{emailErrorMessage}</p>}
                            </div>
                            <div className='divider'></div>
                            <div className='vc-suspend-section'>
                                <div className='title'>Suspend {selectedMember?.name}</div>
                                <div className='description'>Suspending {selectedMember?.name} means they will be permanently suspended from using Ivycorn.</div>
                                <div className={`input-group ${reason ? 'filled' : ''} ${errorMessage && 'show-error'}`}>
                                    <input type="text" id='reasonSuspension' className='' name='reasonSuspension' autoComplete="off" value={reason} onChange={(e) => {
                                        setReason(e.target.value);
                                        if (errorMessage) setErrorMessage('');
                                    }} />
                                    <label htmlFor="reasonSuspension">Reason to suspension</label>
                                </div>
                                {errorMessage && <p className="error-message">{errorMessage}</p>}
                                <button
                                    className={`suspend-button button ${isSuspendLoading ? 'btn_loading' : ''}`}
                                    onClick={() => handleSuspend(selectedMember)}
                                >
                                    {isSuspendLoading ? (
                                        <div className="registerLoader">
                                            <div className="ring-loader"></div>
                                        </div>
                                    ) : (
                                        'Suspend'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='divider full'></div>
                    <div className='save-button-group'>
                        <div className='cancel-button' onClick={() => { setEdit(false); setSelectUser({}); }}>Cancel</div>
                        <button
                            className={`save-button button ${isSaveLoading ? 'btn_loading' : ''}`}
                            onClick={() => { handleSave(); }}
                        >
                            {isSaveLoading ? (
                                <div className="registerLoader">
                                    <div className="ring-loader"></div>
                                </div>
                            ) : (
                                'Save'
                            )}
                        </button>
                    </div>
                </>
            }
        </>
    );
}

export default TeamTab